module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [_c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('fi-footer-mobile'), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutus-mobile"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("关于点点")]), _vm._v(" "), _c('p', [_vm._v("About D.Point")])])]), _vm._v(" "), _c('div', {
    staticClass: "ab-content"
  }, [_c('p', [_vm._v("\n                        点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务。已与国内众多知名金融机构达成深度合作。\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("点点大事记")]), _vm._v(" "), _c('p', [_vm._v("Events Of D.Point")])])]), _vm._v(" "), _c('div', {
    staticClass: "dd-record"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2017.08.16")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点APP上线")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2017.08.25")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("上线9天单日放款金额超100万")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2017.11.27")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点APP用户破百万")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2017.12.21")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("上线120天用户破200万")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.03.20")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点商城上线，甄选正品好货")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.04.28")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点与中国银联达成战略合作，闪付功能上线")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.06.25")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点2.0版本全新上线")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.07.10")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点APP用户破1000万")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.08.01")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("生活缴费功能上线")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("至今")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("我们还在持续优化功能体验")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("点点愿景·一站式金融生活服务平台")]), _vm._v(" "), _c('p', [_vm._v("About Future·A One-stop Financial Service Platform")])])]), _vm._v(" "), _c('div', {
    staticClass: "ab-icon"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("金融")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("商城")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("生活服务")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("充值缴费")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("休闲娱乐")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("线下服务")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0944548"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AboutUsMobile.vue
// module id = 363
// module chunks = 1